/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ResourceType } from '../models/ResourceType';

export class ListAzureSKUsRequest {
  /**
  * The location of skus to list
  */
  'location': string;
  'resourceType': ResourceType;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": "tobedefined"
    },
    {
      "name": "resourceType",
      "baseName": "resourceType",
      "type": "ResourceType",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListAzureSKUsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}



